// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KKHF","top":"styles_top__32Bi3"};